import { IAppRootState } from './IAppRootState';
import { TjipVuexMutation } from '@tjip/vuejs';
import { AppSessionStoreDataModule } from './AppSessionStoreDataModule';
import { ISessionSuspended } from '@/model/ISessionSuspended';

export class AppSessionSuspendedDataModule extends AppSessionStoreDataModule<ISessionSuspended, IAppRootState> {
  private static initialData: ISessionSuspended = {
    lastUrl: undefined
  };
  public namespaced = true;

  constructor() {
    super('sessionSuspended', Object.assign({}, AppSessionSuspendedDataModule.initialData));
  }

  @TjipVuexMutation
  private storeLastUrl(state: ISessionSuspended, value?: string) {
    Object.assign(state, AppSessionSuspendedDataModule.initialData);
    Object.assign(state, { lastUrl: value });
  }
}
